/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import React from 'react';
import { KeyCodes } from '@msdyn365-commerce-modules/utilities';

export interface ISearchBarProps {
    className: string;
    searchPlaceholderLabel: string;
    onSearch(searchText: string): void;
    disabled?: boolean;
}

export interface ISearchBarState {
    searchText: string;
}

export class SearchBar extends React.Component<ISearchBarProps, ISearchBarState> {
    constructor(props: ISearchBarProps) {
        super(props);
        this.state = {
            searchText: ''
        };
    }

    public render(): JSX.Element {
        const { className, searchPlaceholderLabel } = this.props;
        return (
            <div className={`${className}__search`}>
                <input
                    type='text'
                    className={`${className}__searchBar`}
                    disabled={this.props.disabled}
                    placeholder={searchPlaceholderLabel}
                    onChange={this.onSearchTextChange}
                    onKeyUp={this.handleKeyUp}
                />
                <button className={`${className}__searchButton`} disabled={this.props.disabled} onClick={this.onSearch} title={searchPlaceholderLabel} />
            </div>
        );
    }

    private readonly onSearchTextChange = (ev: React.ChangeEvent<HTMLInputElement>): void => {
        this.setState({
            searchText: ev.target.value
        });
    };

    private readonly onSearch = (): void => {
        this.props.onSearch(this.state.searchText);
    };

    private readonly handleKeyUp = (event: React.KeyboardEvent): void => {
        if (event.keyCode === KeyCodes.Enter) {
            this.onSearch();
        }
    };
}
